import { Navigate, useParams } from "react-router-dom";

/**
 * Permanent client-side redirect for the pre-Task-7 Purchase Request detail path
 * (`/purchase-requests-v2/:id`) to its normalised canonical shape (`/purchase-requests/:id`).
 * Old links (emails, bookmarks, the Home dashboard's `actionCopy.ts#routeFor`, import-job "view
 * request" links) are not rewritten everywhere at once, so the old path keeps working via this
 * redirect rather than being deleted. Same shape as `EntityIdRedirect`, kept as its own component
 * (rather than reusing `EntityIdRedirect` with an inline `to`) because it is mounted identically,
 * verbatim, across five role route trees (Analyst/Manager/Buyer/Requester/Admin) and a named
 * component reads clearer at each of those call sites than a repeated inline arrow.
 */
const LegacyPurchaseRequestRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/purchase-requests/${id ?? ""}`} replace />;
};

export default LegacyPurchaseRequestRedirect;
